<template>
    <v-list-item
        v-if="custom"
        :class="{ 'draggable': draggable, 'd-none': !isPageActive(pageSwitchKey)}">
        <v-list-item-icon class="mr-2">
            <v-icon>{{ iconKey }}</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
            <v-list-item-title>
                <slot name="component"></slot>
            </v-list-item-title>
        </v-list-item-content>
        <v-list-item-icon
            v-if="draggable"
            class="mr-2">
            <v-icon>mdi-drag-vertical</v-icon>
        </v-list-item-icon>
    </v-list-item>
    <v-list-item
        v-else
        :class="{ 'draggable': draggable, 'd-none': !isPageActive(pageSwitchKey) }"
        @click="$router.push({ name })">
        <v-list-item-icon class="mr-2">
            <v-icon>{{ iconKey }}</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
            <v-list-item-title>
                {{ title }}
            </v-list-item-title>
        </v-list-item-content>
        <v-list-item-icon
            v-if="draggable"
            class="mr-2">
            <v-icon>mdi-drag-vertical</v-icon>
        </v-list-item-icon>
    </v-list-item>
</template>

<script>
import {mapGetters} from "vuex";

export default{
    props: {
        draggable: {
            type: Boolean,
            default: true
        },
        name: {
            type: String,
            default: null
        },
        title: {
            type: String,
            default: null
        },
        iconKey: {
            type: String,
            default: null
        },
        custom: {
            type: Boolean,
            default: false
        },
        pageSwitchKey: {
            type: String,
            required: false
        },
    },

    computed: {
        ...mapGetters('auth', ['isPageActive'])
    }
}
</script>
